import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonProductCard = () => {
    return (
        <div className="product-card card shadow-sm">
            <Skeleton height={180} />

            <div className="card-body">
                <h6 className="card-title">
                    <Skeleton width={120} />
                </h6>

                <p className="card-text text-muted">
                    <Skeleton count={2} />
                </p>

                <div className="d-flex align-items-center">
                    <Skeleton width={50} />
                    <Skeleton width={70} />
                </div>

                <div className="d-flex align-items-center my-2">
                    <Skeleton width={50} />
                    <Skeleton width={50} />
                </div>

                <div className="d-flex justify-content-between mt-2">
                    <Skeleton width={40} height={40} />
                    <Skeleton width={40} height={40} />
                </div>
            </div>
        </div>
    );
};

export default SkeletonProductCard;
